import type { JiraBrightpickProject } from '@bp/utils';

interface IconLinkProps {
    href: string | null | undefined;
    title: string;
    icon: string;
    classes?: string[];
}

const IconLink = ({ href, title, icon, classes = [] }: IconLinkProps) => {
    if (!href) {
        // Render empty space with same width as icon link
        return (
            <span
                className={'mx-1 d-inline-block align-middle ' + classes.join(' ')}
                style={{ width: '1.5em', height: '1em', verticalAlign: 'middle' }}
                aria-hidden="true"
            ></span>
        );
    }
    return (
        <a className={'mx-1 ' + classes.join(' ')} href={href} title={title} target="_blank" rel="noreferrer">
            <i className={'fs-5 bi ' + icon}></i>
        </a>
    );
};

export function ProjectCardFooter({ project, addClassMaster = '' }: { project: JiraBrightpickProject; addClassMaster?: string }): JSX.Element {
    return (
        <>
            <IconLink href={`/project/${project.projectCodeNormalized}`} title="Project Info" icon="bi-info-circle" classes={[addClassMaster]} />
            <IconLink href={`/project/${project.projectCodeNormalized}/charts`} title="Charts" icon="bi-bar-chart-line" classes={[addClassMaster]} />
            <IconLink href={project.equipmentmap} title="Equipment Mapping" icon="bi-hdd-network" classes={[addClassMaster]} />
            <IconLink href={project.projectFullbook} title="Fullbook" icon="bi-filetype-pdf" classes={[addClassMaster]} />
            <IconLink href={`/product/robots?projectCode=${project.projectCode?.value}`} title="Runners" icon="bi-robot" classes={[addClassMaster]} />
            <IconLink
                href={`https://mission-control.app.${project.projectCodeNormalized}.brightpick.ai`}
                title="Mission Control"
                icon="bi-controller"
                classes={[addClassMaster]}
            />
        </>
    );
}
